import { VendorProductRequestDialog } from "./vendor-product-request-dialog";

// For backward compatibility
export const ProductRequestDialog = VendorProductRequestDialog;
